module.exports = __webpack_public_path__ + "static/media/Monkey.58bd6e6b.png";